export const OPERATION_TYPES = Object.freeze({
  RELATION_RESOLVE_OVERLAP: "relation.resolve_overlap",
  RELATION_CREATE_OR_FIX: "relation.create_or_fix",
  PRODUCT_CREATE_OR_FIX: "product.create_or_fix",
  SETUP_RELATION_AND_PRODUCT: "setup.relation_and_product",
  FINANCIAL_IDENTITY_UPDATE_TAX_NUMBER: "financial_identity.update_tax_number",
  FINANCIAL_IDENTITY_UPDATE_BILLING_PROFILE:
    "financial_identity.update_billing_profile",
  AUTHORIZED_USER_ASSIGN: "authorized_user.assign",
});

export const ISSUE_OPERATION_MAP = Object.freeze({
  overlapping_customer_relation: OPERATION_TYPES.RELATION_RESOLVE_OVERLAP,
  missing_relation: OPERATION_TYPES.RELATION_CREATE_OR_FIX,
  ended_relation: OPERATION_TYPES.RELATION_CREATE_OR_FIX,
  missing_product: OPERATION_TYPES.PRODUCT_CREATE_OR_FIX,
  ended_product: OPERATION_TYPES.PRODUCT_CREATE_OR_FIX,
  missing_both: OPERATION_TYPES.SETUP_RELATION_AND_PRODUCT,
  missing_tax_number: OPERATION_TYPES.FINANCIAL_IDENTITY_UPDATE_TAX_NUMBER,
  invalid_tax_number: OPERATION_TYPES.FINANCIAL_IDENTITY_UPDATE_TAX_NUMBER,
  missing_billing_profile:
    OPERATION_TYPES.FINANCIAL_IDENTITY_UPDATE_BILLING_PROFILE,
  missing_authorized_user: OPERATION_TYPES.AUTHORIZED_USER_ASSIGN,
});

export const ISSUE_LABEL_MAP = Object.freeze({
  overlapping_customer_relation: "Çakışan Müşteri İlişkisi",
  missing_relation: "Eksik Müşteri İlişkisi",
  ended_relation: "Bitmiş Müşteri İlişkisi",
  missing_product: "Eksik Ürün",
  ended_product: "Bitmiş Ürün",
  missing_both: "Eksik Ürün ve Müşteri İlişkisi",
  missing_tax_number: "VKN / TCKN Eksik",
  invalid_tax_number: "VKN / TCKN Geçersiz",
  missing_billing_profile: "Eksik Fatura Profili",
  missing_authorized_user: "Yetkili Kişi Yok",
});

export const operationRegistry = Object.freeze({
  [OPERATION_TYPES.RELATION_RESOLVE_OVERLAP]: {
    label: "Çakışan Müşteri İlişkisini Çöz",
    description:
      "Aynı TYA için çakışan müşteri ilişkilerinden aktif kalacak olanı seçtirir.",
    impact: "Faturalı dönemleri koruyarak ilişki kapatma/silme planı üretir.",
    mode: "overlap_relation",
    namespaces: ["relation_selection"],
    requiredScope: ["relation_id"],
    initialStep: "relation_selection",
  },
  [OPERATION_TYPES.RELATION_CREATE_OR_FIX]: {
    label: "Müşteri İlişkisi Ekle veya Devam Ettir",
    description:
      "Eksik veya hatalı müşteri ilişkisini güvenli tarih sınırlarıyla düzenler.",
    impact: "İlişki değişimi sonrası eksik düzeltme faturası doğabilir.",
    mode: "relation",
    namespaces: ["relation"],
    requiredScope: ["customer_id", "cluster_id"],
    initialStep: "relation",
  },
  [OPERATION_TYPES.PRODUCT_CREATE_OR_FIX]: {
    label: "Ürün Ekle veya Uzat",
    description:
      "Standart ürün dönemini, tutarını veya faturalandırma tipini düzenler.",
    impact:
      "Ürün değişimi sonrası fatura adayı hesabı yeniden değerlendirilir.",
    mode: "product",
    namespaces: ["product"],
    requiredScope: ["customer_id"],
    initialStep: "product",
  },
  [OPERATION_TYPES.SETUP_RELATION_AND_PRODUCT]: {
    label: "Müşteri İlişkisi ve Ürün Ekle",
    description:
      "Müşteri ilişkisi ve standart ürün birlikte eksikse iki adımlı kurulum yapar.",
    impact: "Uygulama işleminde önce ilişkiyi, sonra ürünü oluşturmalıdır.",
    mode: "setup",
    namespaces: ["relation", "product"],
    requiredScope: ["customer_id", "cluster_id"],
    initialStep: "relation",
  },
  [OPERATION_TYPES.FINANCIAL_IDENTITY_UPDATE_TAX_NUMBER]: {
    label: "VKN / TCKN Tamamla",
    description:
      "Resmi fatura için gerekli vergi veya TC kimlik numarasını tamamlar.",
    impact:
      "Geçmiş fatura dönemlerini değiştirmez, yeni resmi fatura bilgisi için gereklidir.",
    mode: "financial_identity",
    namespaces: ["financial_identity"],
    requiredScope: ["customer_id"],
    initialStep: "financial_identity",
  },
  [OPERATION_TYPES.FINANCIAL_IDENTITY_UPDATE_BILLING_PROFILE]: {
    label: "Fatura Profilini Tamamla",
    description:
      "Vergi dairesi, adres, il ve ilçe bilgisini resmi fatura profili için tamamlar.",
    impact: "Paraşüt müşteri bilgisini hazır hale getirir.",
    mode: "financial_identity",
    namespaces: ["billing_profile"],
    requiredScope: ["customer_id"],
    initialStep: "billing_profile",
  },
  [OPERATION_TYPES.AUTHORIZED_USER_ASSIGN]: {
    label: "Yetkili Kişi Ata",
    description:
      "Müşteri iletişimi ve gecikmiş ödeme bildirimleri için yetkili kişi atar.",
    impact:
      "Billing tutarını değiştirmez, operasyonel iletişim bilgisini tamamlar.",
    mode: "authorized_user",
    namespaces: ["authorized_user"],
    requiredScope: ["customer_id"],
    initialStep: "authorized_user",
  },
});

const DEFAULT_WIZARD_STEPS = Object.freeze([
  {
    key: "scope",
    label: "Kapsam",
  },
  {
    key: "operation",
    label: "Operasyon",
  },
  {
    key: "details",
    label: "Detay",
  },
  {
    key: "preview",
    label: "Önizleme",
  },
  {
    key: "result",
    label: "Sonuç",
  },
]);

const setupSteps = Object.freeze([
  {
    key: "relation",
    label: "Müşteri İlişkisi",
  },
  {
    key: "product",
    label: "Standart Ürün",
  },
  {
    key: "preview",
    label: "Önizleme",
  },
  {
    key: "result",
    label: "Sonuç",
  },
]);

const productSteps = Object.freeze([
  {
    key: "product",
    label: "Standart Ürün",
  },
  {
    key: "preview",
    label: "Önizleme",
  },
  {
    key: "result",
    label: "Sonuç",
  },
]);

const relationSteps = Object.freeze([
  {
    key: "relation",
    label: "Müşteri İlişkisi",
  },
  {
    key: "preview",
    label: "Önizleme",
  },
  {
    key: "result",
    label: "Sonuç",
  },
]);

const overlapRelationSteps = Object.freeze([
  {
    key: "relation_selection",
    label: "Müşteri İlişkisi Seçimi",
  },
  {
    key: "preview",
    label: "Önizleme",
  },
  {
    key: "result",
    label: "Sonuç",
  },
]);

const financialIdentitySteps = Object.freeze([
  {
    key: "financial_identity",
    label: "VKN / TCKN",
  },
  {
    key: "preview",
    label: "Önizleme",
  },
  {
    key: "result",
    label: "Sonuç",
  },
]);

const billingProfileSteps = Object.freeze([
  {
    key: "billing_profile",
    label: "Fatura Profili",
  },
  {
    key: "preview",
    label: "Önizleme",
  },
  {
    key: "result",
    label: "Sonuç",
  },
]);

const authorizedUserSteps = Object.freeze([
  {
    key: "authorized_user",
    label: "Yetkili Kişi",
  },
  {
    key: "preview",
    label: "Önizleme",
  },
  {
    key: "result",
    label: "Sonuç",
  },
]);

function hasRelationHistory(preview) {
  return (preview?.relations || []).length > 0;
}

function resolveIssueType(context = {}) {
  const previewIssueType = context?.preview?.source?.issue_type;
  const sourceIssueType = context?.source?.issue_type;

  return previewIssueType || sourceIssueType || null;
}

export const wizardOperationFlows = Object.freeze({
  [OPERATION_TYPES.RELATION_RESOLVE_OVERLAP]: {
    initialStep: "relation_selection",
    steps: overlapRelationSteps,
    modeByStep: {
      relation_selection: "overlap_relation",
    },
    nextStepByStep: {
      relation_selection: "preview",
    },
    draftReadyByStep: {
      relation_selection: "relation_selection",
    },
    issuePillLabel: "Çakışan Müşteri İlişkisi",
    title({ step }) {
      if (step === "relation_selection") {
        return "Çakışan Müşteri İlişkisi: Aktif Kayıt Seçimi";
      }

      if (step === "preview") {
        return "Çakışan Müşteri İlişkisi Önizlemesi";
      }

      if (step === "result") {
        return "Çakışan Müşteri İlişkisi Sonucu";
      }

      return null;
    },
    subtitle({ step }) {
      if (step === "relation_selection") {
        return "Aynı TYA için hangi müşteri ilişkisinin aktif kalacağı seçilir.";
      }

      if (step === "preview") {
        return "Seçime göre ilişki kapatma, silme veya fatura sahibi düzeltme planı kontrol edilir.";
      }

      if (step === "result") {
        return "Uygulanan overlap çözümü ve etkilenen ilişkiler burada özetlenir.";
      }

      return null;
    },
    primaryActionLabels: {
      relation_selection: "Seçimi Kontrol Et ve Önizle",
      preview: "Uygula",
      result: "Tamamlandı",
    },
    footerNotes: {
      relation_selection:
        "Önizleme adımında seçilen ilişkinin güvenli çözüm planı gösterilir.",
      preview: "Plan değiştiyse uygulama reddedilir.",
      result: "Çözüm uygulandığında portföy özeti yenilenir.",
    },
  },
  [OPERATION_TYPES.SETUP_RELATION_AND_PRODUCT]: {
    initialStep: "relation",
    steps: setupSteps,
    modeByStep: {
      relation: "setup",
      product: "setup",
    },
    nextStepByStep: {
      relation: "product",
      product: "preview",
    },
    draftReadyByStep: {
      relation: "relation",
      product: "setup",
      details: "setup",
    },
    issuePillLabel: "Eksik Ürün ve Müşteri İlişkisi",
    title({ step, preview }) {
      if (step === "relation") {
        return hasRelationHistory(preview)
          ? "Eksik Ürün ve Müşteri İlişkisi: Müşteri İlişkisini Devam Ettir"
          : "Eksik Ürün ve Müşteri İlişkisi: Müşteri İlişkisi Ekle";
      }

      if (step === "product") {
        return "Eksik Ürün ve Müşteri İlişkisi: Ürün Ekle";
      }

      if (step === "preview") {
        return "Eksik Ürün ve Müşteri İlişkisi Önizlemesi";
      }

      if (step === "result") {
        return "Eksik Ürün ve Müşteri İlişkisi Sonucu";
      }

      return null;
    },
    subtitle({ step, preview }) {
      if (step === "relation") {
        return hasRelationHistory(preview)
          ? "Bitmiş ilişki sonrası yeni devam ilişkisi önerilir."
          : "İlk adım sadece müşteri-TYA ilişkisini çözer.";
      }

      if (step === "product") {
        return "Müşteri ilişkisi kontrol edildi; şimdi standart ürün bilgisi tamamlanır.";
      }

      if (step === "preview") {
        return "Müşteri ilişkisi ve ürün çözüm planı policy tarafından kontrol edilir.";
      }

      if (step === "result") {
        return "Uygulanan işlem ve oluşan kayıtlar burada özetlenir.";
      }

      return null;
    },
    primaryActionLabels: {
      relation: "Kontrol Et ve Devam Et",
      product: "Ürünü Kontrol Et ve Önizle",
      preview: "Uygula",
      result: "Tamamlandı",
    },
    footerNotes: {
      relation: "Müşteri ilişkisi kontrol edilince ürün adımı açılır.",
      product: "Ürün kontrol edilince son önizleme açılır.",
      preview: "Plan değiştiyse uygulama reddedilir.",
      result: "Çözüm uygulandığında portföy özeti yenilenir.",
    },
  },
  [OPERATION_TYPES.PRODUCT_CREATE_OR_FIX]: {
    initialStep: "product",
    steps: productSteps,
    modeByStep: {
      product: "product",
    },
    nextStepByStep: {
      product: "preview",
    },
    draftReadyByStep: {
      product: "product",
      details: "product",
    },
    issuePillLabel: "Eksik Ürün",
    title(context) {
      const step = context?.step;
      const issueType = resolveIssueType(context);

      if (step === "product") {
        return issueType === "ended_product"
          ? "Bitmiş Ürün: Ürünü Uzat"
          : "Eksik Ürün: Ürün Ekle";
      }

      if (step === "preview") {
        return issueType === "ended_product"
          ? "Bitmiş Ürün Önizlemesi"
          : "Eksik Ürün Önizlemesi";
      }

      if (step === "result") {
        return issueType === "ended_product"
          ? "Bitmiş Ürün Sonucu"
          : "Eksik Ürün Sonucu";
      }

      return null;
    },
    subtitle(context) {
      const step = context?.step;
      const issueType = resolveIssueType(context);

      if (step === "product") {
        return issueType === "ended_product"
          ? "Önceki standart ürün dönemi bitmiş. Yeni dönem güvenli başlangıçla açılır."
          : "Mevcut müşteri ilişkisi korunur; standart ürün dönemi tamamlanır.";
      }

      if (step === "preview") {
        return "Ürün çözüm planı policy tarafından kontrol edilir.";
      }

      if (step === "result") {
        return "Uygulanan ürün işlemi ve oluşan kayıtlar burada özetlenir.";
      }

      return null;
    },
    primaryActionLabels: {
      product: "Ürünü Kontrol Et ve Önizle",
      preview: "Uygula",
      result: "Tamamlandı",
    },
    footerNotes: {
      product: "Ürün kontrol edilince son önizleme açılır.",
      preview: "Plan değiştiyse uygulama reddedilir.",
      result: "Çözüm uygulandığında portföy özeti yenilenir.",
    },
  },
  [OPERATION_TYPES.RELATION_CREATE_OR_FIX]: {
    initialStep: "relation",
    steps: relationSteps,
    modeByStep: {
      relation: "relation",
    },
    nextStepByStep: {
      relation: "preview",
    },
    draftReadyByStep: {
      relation: "relation",
      details: "relation",
    },
    issuePillLabel: "Eksik Müşteri İlişkisi",
    title(context) {
      const step = context?.step;
      const preview = context?.preview;
      const issueType = resolveIssueType(context);

      if (step === "relation") {
        if (issueType === "ended_relation") {
          return "Bitmiş Müşteri İlişkisi: Müşteri İlişkisini Devam Ettir";
        }

        return hasRelationHistory(preview)
          ? "Eksik Müşteri İlişkisi: Müşteri İlişkisini Devam Ettir"
          : "Eksik Müşteri İlişkisi: Müşteri İlişkisi Ekle";
      }

      if (step === "preview") {
        return issueType === "ended_relation"
          ? "Bitmiş Müşteri İlişkisi Önizlemesi"
          : "Eksik Müşteri İlişkisi Önizlemesi";
      }

      if (step === "result") {
        return issueType === "ended_relation"
          ? "Bitmiş Müşteri İlişkisi Sonucu"
          : "Eksik Müşteri İlişkisi Sonucu";
      }

      return null;
    },
    subtitle(context) {
      const step = context?.step;
      const preview = context?.preview;
      const issueType = resolveIssueType(context);

      if (step === "relation") {
        if (issueType === "ended_relation") {
          return "Önceki müşteri ilişkisi bitmiş. Yeni ilişki son kapanışın ertesi günüyle başlar.";
        }

        return hasRelationHistory(preview)
          ? "Bitmiş müşteri ilişkisi sonrası yeni devam ilişkisi önerilir."
          : "TYA için müşteri ilişkisi tarihi tamamlanır.";
      }

      if (step === "preview") {
        return "Müşteri ilişkisi çözüm planı policy tarafından kontrol edilir.";
      }

      if (step === "result") {
        return "Uygulanan ilişki işlemi ve oluşan kayıtlar burada özetlenir.";
      }

      return null;
    },
    primaryActionLabels: {
      relation: "Müşteri İlişkisini Kontrol Et ve Önizle",
      preview: "Uygula",
      result: "Tamamlandı",
    },
    footerNotes: {
      relation: "Müşteri ilişkisi kontrol edilince son önizleme açılır.",
      preview: "Plan değiştiyse uygulama reddedilir.",
      result: "Çözüm uygulandığında portföy özeti yenilenir.",
    },
  },
  [OPERATION_TYPES.FINANCIAL_IDENTITY_UPDATE_TAX_NUMBER]: {
    initialStep: "financial_identity",
    steps: financialIdentitySteps,
    modeByStep: {
      financial_identity: "financial_identity",
    },
    nextStepByStep: {
      financial_identity: "preview",
    },
    draftReadyByStep: {
      financial_identity: "financial_identity",
    },
    issuePillLabel: "Vergi No Eksik",
    title({ step }) {
      if (step === "financial_identity") {
        return "Vergi Kimliği: VKN / TCKN";
      }

      if (step === "preview") {
        return "Vergi Kimliği Önizlemesi";
      }

      if (step === "result") {
        return "Vergi Kimliği Sonucu";
      }

      return null;
    },
    subtitle({ step }) {
      if (step === "financial_identity") {
        return "Resmi fatura için gerekli vergi kimliği kaydedilir.";
      }

      if (step === "preview") {
        return "VKN / TCKN değişikliği uygulama öncesi policy tarafından kontrol edilir.";
      }

      if (step === "result") {
        return "Kaydedilen vergi kimliği ve sonuç özeti burada gösterilir.";
      }

      return null;
    },
    primaryActionLabels: {
      financial_identity: "Bilgiyi Kontrol Et ve Önizle",
      preview: "Uygula",
      result: "Tamamlandı",
    },
    footerNotes: {
      financial_identity:
        "Vergi No / Kimlik No doğrulandığında çözüm planı görüntülenebilir.",
      preview: "Plan değiştiyse uygulama reddedilir.",
      result: "Çözüm uygulandığında portföy özeti yenilenir.",
    },
  },
  [OPERATION_TYPES.FINANCIAL_IDENTITY_UPDATE_BILLING_PROFILE]: {
    initialStep: "billing_profile",
    steps: billingProfileSteps,
    modeByStep: {
      billing_profile: "financial_identity",
    },
    nextStepByStep: {
      billing_profile: "preview",
    },
    draftReadyByStep: {
      billing_profile: "billing_profile",
    },
    issuePillLabel: "Fatura Profili Eksik",
    title({ step }) {
      if (step === "billing_profile") {
        return "Fatura Profili: Resmi Alanlar";
      }

      if (step === "preview") {
        return "Fatura Profili Önizlemesi";
      }

      if (step === "result") {
        return "Fatura Profili Sonucu";
      }

      return null;
    },
    subtitle({ step }) {
      if (step === "billing_profile") {
        return "Vergi dairesi, adres ve konum bilgileri resmi profil için tamamlanır.";
      }

      if (step === "preview") {
        return "Fatura profili değişikliği uygulama öncesi policy tarafından kontrol edilir.";
      }

      if (step === "result") {
        return "Kaydedilen profil bilgileri ve sonuç özeti burada gösterilir.";
      }

      return null;
    },
    primaryActionLabels: {
      billing_profile: "Profili Kontrol Et ve Önizle",
      preview: "Uygula",
      result: "Tamamlandı",
    },
    footerNotes: {
      billing_profile: "Profil bilgileri kontrol edilince son önizleme açılır.",
      preview: "Plan değiştiyse uygulama reddedilir.",
      result: "Çözüm uygulandığında portföy özeti yenilenir.",
    },
  },
  [OPERATION_TYPES.AUTHORIZED_USER_ASSIGN]: {
    initialStep: "authorized_user",
    steps: authorizedUserSteps,
    modeByStep: {
      authorized_user: "authorized_user",
    },
    nextStepByStep: {
      authorized_user: "preview",
    },
    draftReadyByStep: {
      authorized_user: "authorized_user",
    },
    issuePillLabel: "Yetkili Kişi Yok",
    title({ step }) {
      if (step === "authorized_user") {
        return "Yetkili Kişi: Kullanıcı Ata";
      }

      if (step === "preview") {
        return "Yetkili Kişi Önizlemesi";
      }

      if (step === "result") {
        return "Yetkili Kişi Sonucu";
      }

      return null;
    },
    subtitle({ step }) {
      if (step === "authorized_user") {
        return "Operasyon iletişimi için müşteriye bir kullanıcı atanır.";
      }

      if (step === "preview") {
        return "Yetkili kişi ataması uygulama öncesi policy tarafından kontrol edilir.";
      }

      if (step === "result") {
        return "Atanan kullanıcı ve sonuç özeti burada gösterilir.";
      }

      return null;
    },
    primaryActionLabels: {
      authorized_user: "Kişiyi Kontrol Et ve Önizle",
      preview: "Uygula",
      result: "Tamamlandı",
    },
    footerNotes: {
      authorized_user: "Seçim kontrol edilince son önizleme açılır.",
      preview: "Plan değiştiyse uygulama reddedilir.",
      result: "Çözüm uygulandığında portföy özeti yenilenir.",
    },
  },
});

export const WIZARD_SUPPORTED_OPERATION_TYPES = Object.freeze(
  Object.keys(wizardOperationFlows)
);

export function getOperationOptions() {
  return Object.keys(operationRegistry).map((operationType) => ({
    type: operationType,
    ...operationRegistry[operationType],
  }));
}

export function getWizardOperationOptions() {
  return WIZARD_SUPPORTED_OPERATION_TYPES.map((operationType) => ({
    type: operationType,
    ...operationRegistry[operationType],
  }));
}

export function getOperationTypeForIssue(issueType) {
  return ISSUE_OPERATION_MAP[issueType] || null;
}

export function getIssueTypeLabel(issueType) {
  return ISSUE_LABEL_MAP[issueType] || null;
}

export function getOperationDefinition(operationType) {
  return operationRegistry[operationType] || null;
}

export function getDefaultWizardSteps() {
  return DEFAULT_WIZARD_STEPS;
}

export function getWizardFlowDefinition(operationType) {
  return wizardOperationFlows[operationType] || null;
}

export function isWizardOperationSupported(operationType) {
  return Boolean(getWizardFlowDefinition(operationType));
}

export function isIssueOperationSupported(issueType) {
  return Boolean(getOperationTypeForIssue(issueType));
}
